// @ts-check

// Currencies are listed in order of popularity

const currencies = {
  default_currency:
    /** @type {import("@app/types/currency").CurrencyCode} */ "USD",
  supported: {
    USD: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "United States Dollar"
    },
    EUR: {
      symbol: "€",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Euro"
    },
    CAD: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Canadian Dollar"
    },
    ARS: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 1,
      decimal_points: 2,
      label: "Argentine Peso"
    },
    AUD: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Australian Dollar"
    },
    BRL: {
      symbol: "R$",
      symbol_left: 1,
      space: 1,
      cents: 1,
      commas: 1,
      decimal_points: 2,
      label: "Brazilian Real"
    },
    CHF: {
      symbol: "CHF",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Swiss Franc"
    },
    CLP: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 0,
      commas: 0,
      decimal_points: 2,
      label: "Chilean Peso"
    },
    CNY: {
      symbol: "¥",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Chinese Yuan"
    },
    COP: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 0,
      commas: 0,
      decimal_points: 2,
      label: "Colombian Peso"
    },
    CZK: {
      symbol: "Kč",
      symbol_left: 0,
      space: 1,
      cents: 1,
      commas: 1,
      decimal_points: 2,
      label: "Czech Koruna"
    },
    DKK: {
      symbol: "kr",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Danish Krone"
    },
    GBP: {
      symbol: "£",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "British Pound"
    },
    HKD: {
      symbol: "HK$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Hong Kong Dollar"
    },
    ILS: {
      symbol: "₪",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Israeli New Shekel"
    },
    INR: {
      symbol: "₹",
      symbol_left: 1,
      space: 0,
      cents: 0,
      commas: 1,
      decimal_points: 2,
      label: "Indian Rupee"
    },
    JPY: {
      symbol: "¥",
      symbol_left: 1,
      space: 0,
      cents: 0,
      commas: 0,
      decimal_points: 0,
      label: "Japanese Yen"
    },
    KRW: {
      symbol: "₩",
      symbol_left: 1,
      space: 0,
      cents: 0,
      commas: 0,
      decimal_points: 0,
      label: "South Korean Won"
    },
    MAD: {
      symbol: "dh",
      symbol_left: 0,
      space: 1,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Moroccan Dirham"
    },
    MXN: {
      symbol: "$",
      symbol_left: 1,
      space: 1,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Mexican Peso"
    },
    NOK: {
      symbol: "kr",
      symbol_left: 1,
      space: 1,
      cents: 1,
      commas: 1,
      decimal_points: 2,
      label: "Norwegian Krone"
    },
    NZD: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "New Zealand Dollar"
    },
    PEN: {
      symbol: "S/",
      symbol_left: 1,
      space: 1,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Peruvian Sol"
    },
    PLN: {
      symbol: "zł",
      symbol_left: 0,
      space: 1,
      cents: 1,
      commas: 1,
      decimal_points: 2,
      label: "Polish Zloty"
    },
    RUB: {
      symbol: "р",
      symbol_left: 0,
      space: 0,
      cents: 1,
      commas: 1,
      decimal_points: 2,
      label: "Russian Ruble"
    },
    SEK: {
      symbol: "kr",
      symbol_left: 0,
      space: 1,
      cents: 0,
      commas: 0,
      decimal_points: 2,
      label: "Swedish Krona"
    },
    SGD: {
      symbol: "S$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Singapore Dollar"
    },
    THB: {
      symbol: "฿",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Thai Baht"
    },
    TRY: {
      symbol: "₺",
      symbol_left: 0,
      space: 0,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "Turkish Lira"
    },
    ZAR: {
      symbol: "R",
      symbol_left: 1,
      space: 1,
      cents: 1,
      commas: 0,
      decimal_points: 2,
      label: "South African Rand"
    }
  }
};

/**
 * Sort currency codes by their formatted values
 *
 * @param {import("@app/types/currency").CurrencyCode[]} currency_codes
 * @param {(code: import("@app/types/currency").CurrencyCode) => string} currency_formatter
 * @returns {import("@app/types/currency").CurrencyCode[]}
 */
export function sortCurrencies(currency_codes, currency_formatter) {
  const sorted_codes = currency_codes
    .map(
      code =>
        /** @type {[string, import("@app/types/currency").CurrencyCode]} */ ([
          currency_formatter(code),
          code
        ])
    )
    .sort((a, b) => {
      if (a[0] > b[0]) {
        return 1;
      }
      if (b[0] > a[0]) {
        return -1;
      }
      return 0;
    })
    .map(code_tuple => {
      return code_tuple[1];
    });

  return sorted_codes;
}

/**
 * Returns all supported currencies sorted by their formatted values
 *
 * @param {(code: import("@app/types/currency").CurrencyCode) => string} currency_formatter
 * @returns {import("@app/types/currency").CurrencyCode[]}
 */
export function getAllSortedCurrencyCodes(currency_formatter) {
  return sortCurrencies(currency_codes, currency_formatter);
}

/** @type {import("@app/types/currency").CurrencyCode[]} */
export const popular_currencies = ["USD", "CAD", "EUR"];

/** @type {import("@app/types/currency").CurrencyCode[]} */
// prettier-ignore
export const currency_codes = /** @type {import("@app/types/currency").CurrencyCode[]} */ (Object.keys(
  currencies.supported
));

export default currencies;

export const currencies_count = currency_codes.length;
